module.exports = __webpack_public_path__ + "img/oufu_81x104x11b.prt.ea68a726.jpg";